// Dashboard.js
import React, { useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
  Paper,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';

function Dashboard() {
    
      
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ background: '#004d40' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Welcome Back, <strong>Charles J Pintel</strong>
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 3 }}>
        {/* Top Navigation Buttons */}
        <Grid container spacing={2} mb={3}>
          {['Dashboard', 'Work Orders', 'Payment Center', 'Service Requests'].map((label) => (
            <Grid item key={label}>
              <Paper elevation={2} sx={{ px: 2, py: 1.5, minWidth: 140, textAlign: 'center' }}>
                <Typography variant="button">{label}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Job Overview and Calendar */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  📋 Job Overview:
                </Typography>
                <Typography variant="body2" gutterBottom>
                  Manage your work orders at a glance.
                </Typography>
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={4}>
                    <Paper sx={{ background: '#004d40', color: 'white', p: 2 }}>
                      <Typography variant="h4" align="center">19</Typography>
                      <Typography align="center">All Jobs</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper sx={{ background: '#ef6c00', color: 'white', p: 2 }}>
                      <Typography variant="h4" align="center">15</Typography>
                      <Typography align="center">In Progress</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper sx={{ background: '#2e7d32', color: 'white', p: 2 }}>
                      <Typography variant="h4" align="center">4</Typography>
                      <Typography align="center">Completed</Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Calendar */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  📅 Calendar:
                </Typography>
                <Typography variant="body2" gutterBottom>
                  View your upcoming scheduled appointments.
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Grid container spacing={1}>
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, i) => (
                    <Grid item xs key={day}>
                      <Typography align="center" variant="caption" fontWeight="bold">{day}</Typography>
                      <Typography align="center" variant="body2">{`08/${i + 3}`}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Lower Panels */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1">🛠 Jobs In Progress:</Typography>
              <Typography variant="body2">Keep track of current work orders in progress.</Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1">⚙️ Service Request Queue:</Typography>
              <Typography variant="body2">View available service request(s).</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default Dashboard;
